export default "__VITE_ASSET__aefa8ebc__"